import { isJsonObject } from "../errors.js";
/**
 * The #1815 interim "search the node on the LAN" seam. Client-only vertical slice: the
 * discovery screen probes explicit candidate addresses (manually entered today, a signed
 * bootstrap descriptor's `lan_candidates` in the Phase-2 follow-on — see
 * `docs/superpowers/plans/2026-07-25-client-node-lan-discovery.md`) and the kernel reports
 * live per-candidate progress. Mirrors `./onboarding-contract.ts`'s idiom: locked wire-name
 * constants + JSON-safe view/payload types + a runtime validator per command payload.
 *
 * `DISCOVERY_QUERY` is both a one-shot `query()` and a `liveQuery()` name (the kernel's
 * `LiveQueryDefinition` row type is `DiscoveryCandidateView`, keyed by `address`) — the same
 * dual usage every other query in `@econ-v1/kernel`'s `LiveQueryEngine` supports.
 */
export const DISCOVERY_QUERY = "onboarding.discovery.v1";
export const DISCOVERY_PROBE_COMMAND = "onboarding.discovery.probe.v1";
export const DISCOVERY_PROMOTE_COMMAND = "onboarding.discovery.promote.v1";
/**
 * The pre-pairing "is this address really a node" check (lan-direct-pairing plan). Unlike
 * `DISCOVERY_PROBE_COMMAND` (which re-proves a candidate against an *already-known* home-node
 * id), this takes one address the person just typed in and asks it to prove itself via its
 * public origin proof alone — no session, no expected node id, no auth headers.
 */
export const DISCOVER_NODE_COMMAND = "onboarding.discovery.discover-node.v1";
export function isProbeCandidatesPayload(value) {
    if (!isJsonObject(value))
        return false;
    const { addresses } = value;
    return Array.isArray(addresses)
        && addresses.length > 0
        && addresses.every((item) => typeof item === "string" && item.trim().length > 0);
}
export function isPromoteCandidatePayload(value) {
    if (!isJsonObject(value))
        return false;
    return typeof value.address === "string" && value.address.trim().length > 0;
}
export function isDiscoverNodePayload(value) {
    if (!isJsonObject(value))
        return false;
    return typeof value.address === "string" && value.address.trim().length > 0;
}
//# sourceMappingURL=discovery-contract.js.map